export enum PromotionType {
  DISCOUNT_NOT_MIX = "DISCOUNT_NOT_MIX",
  FREEBIES_NOT_MIX = "FREEBIES_NOT_MIX",
}

export const PROMOTION_TYPE_NAME: any = {
  DISCOUNT_NOT_MIX: "ส่วนลดแบบไม่คละ SKU",
  FREEBIES_NOT_MIX: "ของแถมแบบไม่คละ SKU",
};
